import Vue from 'vue'
import Router from 'vue-router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import HelloWorld from '@/components/HelloWorld'
import how from '@/components/how'
import situation from '@/components/situation'
import article from '@/components/article'
import service from '@/components/service'
import services from '@/components/services'
import group from '@/components/group'
import contacts from '@/components/contacts'

Vue.use(Loading)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/how-it-works',
      name: 'how',
      component: how
    },
    {
      path: '/groups/:id',
      name: 'group',
      component: group
    },
    {
      path: '/services/:id',
      name: 'service',
      component: service
    },
    {
      path: '/service/:id',
      name: 'services',
      component: services
    },
    {
      path: '/situation/:id',
      name: 'situation',
      component: situation
    },
    {
      path: '*',
      name: 'article',
      component: article
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: contacts
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})
let loader
router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: '#000',
      color: '#FA5663',
      isFullPage: true
    })
  }
  next()
})

router.afterEach((to, from) => {
  loader.hide()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js